import type { MentionDescription } from '@atlaskit/mention';
import { forNamespace } from '@trello/legacy-i18n';
import { dangerouslyConvertPrivacyString } from '@trello/privacy';

import type { TrelloMember } from './TrelloMember';

const format = forNamespace('automentioner');

export function toSpecialMention(
  specialMention: TrelloMember,
): MentionDescription {
  let name = dangerouslyConvertPrivacyString(specialMention.fullName) ?? '';

  // Translate the text of the special mention and append the user count
  if (specialMention.id === 'card_mention_id') {
    name = `${format('all-members-on-card')} (${specialMention.userCount})`;
  } else if (specialMention.id === 'board_mention_id') {
    name = `${format('all-members-on-board')} (${specialMention.userCount})`;
  }

  // We append the the user count to the id of these special mentions because
  // the mention picker component in Editor seems to cache these mentions by
  // id and the count in the fullName doesn't update when switching from one
  // card to another or when the count changes.
  const id = `${specialMention.id}_${specialMention.userCount}`;

  return {
    id,
    name,
    nickname: dangerouslyConvertPrivacyString(specialMention.username),
    mentionName: dangerouslyConvertPrivacyString(specialMention.username),
    userType: 'special',
  };
}
